import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { tenantService } from "../../Services/tenant.service";

const LogoDelete = ({
  showDeleteLogo,
  handleHideDeleteLogo,
  tenantId,
  setUpdate,
}) => {
  const { t: translator } = useTranslation();

  const handleSubmit = () => {
    tenantService
      .deleteLogo(tenantId)
      .then((res) => {
        handleHideDeleteLogo();
        setUpdate(new Date());
      })
      .catch((err) => console.log(err));
  };

  return (
    <Modal show={showDeleteLogo} onHide={handleHideDeleteLogo} centered>
      <Modal.Header>
        <Modal.Title>{translator("Remove-Logo")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{translator("DeleteLogo-Msg")}?</Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-secondary"
          data-dismiss="modal"
          onClick={handleHideDeleteLogo}
        >
          {translator("Btn-Cancel")}
        </button>
        <button
          onClick={handleSubmit}
          type="button"
          className="btn btn-primary"
        >
          {translator("Confirm")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default LogoDelete;
